import { isEmail } from "commons-validator-es";
import { addMethod, string, StringSchema } from "yup";

declare module "yup" {
  interface StringSchema {
    apacheMail(errorMessage: string): this;
  }
}

function isApacheMail(this: StringSchema, message: string) {
  return this.test("apacheMail", message, function (value) {
    const { path, createError } = this;

    if (!value) {
      return createError({ path, message: message });
    }

    if (isEmail(value) === false) return createError({ path, message: message });

    return true;
  });
}
addMethod(string, "apacheMail", isApacheMail);
